// @flow
import KlassesEmployees from './KlassesEmployees';

export default KlassesEmployees;
